import { GET_INCIDENT_COUNT_SUCCESS } from "../types";

export const setIncidentCount = (data) => {
  return {
    type: GET_INCIDENT_COUNT_SUCCESS,
    payload: data,
  };
};
